export default {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    on(fn, options = {}) { },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    remove(fn) { },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    once(fn, options = {}) { }
};
